export const ALIAS_DEFAULT_VALUE = 'SELECTED_TEXT';
export const EDITOR_USER_GROUP = 'Professional_editor';
export const ADMIN_USER_GROUP = 'Production_manager';
